import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './user.css'
import {message,TreeSelect} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import 'moment/locale/ar';
import {SearchOutlined} from '@ant-design/icons';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
let headers = [
  { label: "#", key: "id" },
  { label: "FullName", key: "fullname" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Country", key: "country" },
];
 
let csvData = [
  
];
class Users extends React.Component {
  
  state={
    users:[],
    users2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    collapsed: false,
    filterType:{},
    value:'',
    count:0,
    countries:[],
    country:null,
    gender:null,
    area:null,
    city:null,
    accountType:null,
    search:null,
    csvData:[]
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    console.log('hhh')
    this.getUsers(1)
    window.scrollTo(0,0)
    this.getCountries()
    this.getUsersWithoutPagenation()

    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }
  /**
  * get counries with pagenation request 
  */
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
    .then(response=>{
      console.log(response.data)
      this.setState({countries:response.data.data})
    })
    .catch(error=>{
      console.log("ALL countries ERROR")
      console.log(error.response)
    })
  }
  /**
  * get data with pagenation request 
  */
  getUsers = (page,rest) =>{
    this.setState({loading:true})
    let url = `${BASE_END_POINT}getAll?type=USER&accountType=ACTIVE&page=${page}`
    let {country,accountType,search,gender} = this.state
    if(country !== null){
      let str = '&country='+ country
      url += str
    }
    if(gender !== null){
      let str = '&gender='+ gender
      url += str
    }
    
    if(accountType !== null){
      let str = '&accountType='+ accountType
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}getAll?type=USER&accountType=ACTIVE&page=${page}`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.fullname?item.fullname:'',
        item.img?{type:"img",img:item.img}:{type:"img",img:null},
        item.email?item.email:"",
        item.accountType==="ACTIVE"?{type:'tag',value:allStrings.active}:{type:'tag',value:allStrings.notActive} ,
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        users:response.data.data,
        users2:data,
        //page:response.data.page,
        pages:response.data.pageCount,
        count:response.data.totalCount
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  /**
  * get data without pagenation request 
  */
  getUsersWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}withoutPagenation/get?type=USER&accountType=ACTIVE`
    let {country,accountType,search,gender} = this.state
    if(country !== null){
      let str = '&country='+ country
      url += str
    }
    if(gender !== null){
      let str = '&gender='+ gender
      url += str
    }
   
    if(accountType !== null){
      let str = '&accountType='+ accountType
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}withoutPagenation/get?type=USER&accountType=ACTIVE`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data)
        csvData= response.data.users.map(item => {
          return {
            ...{id:item.id},
            ...{fullname:item.fullname?item.fullname:''},
            ...{email:item.email?item.email:""},
            ...{phone:item.phone},
            ...{country:item.country?item.country.countryName:""},
          };
        });
        console.log(csvData)
        this.setState({csvData:csvData})
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }

  /**
  * delete request 
  */
  deleteUser = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}/${id}/delete`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("USER DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getUsers(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
    })
 }

  /**
  * pagination Buttons component
  */
  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getUsers(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getUsers(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getUsers(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} 
        style={{color:`#117183 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getUsers(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getUsers(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />
    return (
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          
          <Table
            /**table settings contain reload and csv  */
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,country:null,accountType:null});this.getUsers(1,false,true);this.getUsersWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"users.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink>
              </div>
              
            }
            /**table filter  */
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass':'hideClass'} style={{height:this.state.showFilter?"250px":"0px"}}>
                  <MDBRow>
                    
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.gender}</label>
                      <TreeSelect virtual={false}
                          showSearch={false}
                          value={this.state.gender}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.gender}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({gender:value});
                          }} 
                      
                      >
                          <TreeNode value="MALE" title={allStrings.male} key="MALE" />
                          <TreeNode value="FEMALE" title={allStrings.female} key="FEMALE" />
                        
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.country}</label>
                        <TreeSelect virtual={false}
                            showSearch={false}
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}         
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.country}
                            value={this.state.country}
                            showCheckedStrategy= {SHOW_PARENT}
                            onChange={(value) => {
                            console.log(value)
                            this.setState({country:value});
                            //this.getCities(value)
                            }} 
                        
                        >
                            {this.state.countries.map(val=>(
                                <TreeNode value={val.id} title={this.props.isRTL?val.countryName_ar:val.countryName_en} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.accountType}</label>
                      <TreeSelect virtual={false}
                          showSearch={false}
                          value={this.state.accountType}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.accountType}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({accountType:value});
                          }} 
                      
                      >
                          <TreeNode value="ACTIVE" title={allStrings.active} key="ACTIVE" />
                          <TreeNode value="BLOCKED" title={allStrings.blocked} key="BLOCKED" />
                          <TreeNode value="NOT-ACTIVE" title={allStrings.notActive} key="NOT-ACTIVE" />
                        
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="12" lg="12" md="12" sm="12">
                      <div class="md-form">
                      <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.filterSearch}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                  <MDBCol md="12">
                    <Button style={{background: '#117183',color: '#fff',width: '100%',margin: '32px auto'}} 
                      onClick={()=>{this.getUsers(1);this.getUsersWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                    </MDBCol>
                  </MDBRow>
                  
                </div>
              </div>
            }
            title={allStrings.users}
            lang={this.props.isRTL}
            icon='group'
            data={this.state.users}
            data2={this.state.users2}
            tableColumns={["#",allStrings.name,allStrings.img,allStrings.email,allStrings.accountType,allStrings.action]}
            loading={this.state.loading}
            deleteUser={(id)=>{this.deleteUser(id)}}
            path='/UserInfo'
            actionIndex={7}
            enableDelete={this.props.currentUser.user.type ==="ADMIN"?true:false}
            />
            {this.paginationButtons()}
              
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Users)
);

